"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1148,6976],{

/***/ 472327:
/***/ (function(module) {



function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-var-requires */
/** Delimiter to be used for separating child properties */
var CHILD_DELIMITER = "-";

/** Child properties starting with this, will be available directly like color-primary, instead of color-primary-main */
var DEFAULT_CHILDREN = "__";
var DESCRIPTION_PROPERTY = "__description";

/**
 * @typedef {{key: keyName, value: obj}} CssVariable
 */

var isPrimitive = function isPrimitive(value) {
  return ["string", "number", "boolean"].includes(_typeof(value));
};
var parseThemeObject = function parseThemeObject(theme) {
  /**
   * @type {CssVariable[]}
   */
  var cssVariables = [];
  var parseRecursively = function parseRecursively(obj) {
    var keyPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (isPrimitive(obj)) {
      // primitive
      var keyName = keyPath.join(CHILD_DELIMITER);
      var thisKey = keyPath.pop();
      if (thisKey === DEFAULT_CHILDREN) {
        keyName = keyPath.join(CHILD_DELIMITER);
      }
      cssVariables.push({
        key: keyName,
        value: obj
      });
      return;
    }
    Object.entries(obj).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (Array.isArray(value)) {
        value.forEach(function (singleVal, index) {
          return parseRecursively(singleVal, [].concat(_toConsumableArray(keyPath), [key, index]));
        });
      }
      parseRecursively(value, [].concat(_toConsumableArray(keyPath), [key]));
    });
  };
  parseRecursively(theme);
  return cssVariables;
};

/**
 * Get Line to be injected in CSS/Scss
 * @param {String} key
 * @param {String} value
 * @param {'css' | 'scss'} type
 */
var getVariableLine = function getVariableLine(key, value) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "css";
  if (key.includes(DESCRIPTION_PROPERTY)) {
    return "/* ".concat(value, " */");
  }
  if (type === "css") {
    key = "--".concat(key);
  }
  if (type === "scss") {
    key = "$".concat(key);
    value = JSON.stringify(value || "");
  }
  return "".concat(key, ": ").concat(value || '""', ";");
};

/**
 *
 * @param {CssVariable[]} cssVariables
 * @returns css-variables surrounded by :root
 */
var getCssContent = function getCssContent(cssVariables) {
  var cssVariablesStr = cssVariables.map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value;
    return getVariableLine(key, value, "css");
  }).join("\n  ");
  cssVariablesStr = ":root{\n  ".concat(cssVariablesStr, "\n}");
  return cssVariablesStr;
};
var getScssContent = function getScssContent(cssVariables) {
  var scssVariablesStr = cssVariables.map(function (_ref4) {
    var key = _ref4.key,
      value = _ref4.value;
    return getVariableLine(key, value, "scss");
  }).join("\n");
  return scssVariablesStr;
};
var getCssFromThemeObject = function getCssFromThemeObject(theme) {
  var cssVariables = parseThemeObject(theme);
  return getCssContent(cssVariables);
};
module.exports = {
  getCssContent: getCssContent,
  getScssContent: getScssContent,
  getCssFromThemeObject: getCssFromThemeObject,
  parseThemeObject: parseThemeObject
};

/***/ }),

/***/ 952301:
/***/ (function(module) {



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-undef */

var colors = {
  accent: {
    100: "#D8E5FE",
    200: "#B1C9FE",
    300: "#8AABFE",
    400: "#6D92FD",
    500: "#3D6AFD",
    600: "#2C50D9",
    700: "#1E3AB6",
    800: "#132892",
    900: "#0B1A79"
  },
  success: {
    100: "#F1FBD1",
    200: "#E1F8A4",
    300: "#C5EC73",
    400: "#A7D94E",
    500: "#7FC11D",
    600: "#65A515",
    700: "#4E8A0E",
    800: "#3A6F09",
    900: "#2B5C05"
  },
  warning: {
    100: "#FFFAD6",
    200: "#FFF4AD",
    300: "#FFEC83",
    400: "#FFE565",
    500: "#FFD932",
    600: "#DBB524",
    700: "#B79419",
    800: "#93730F",
    900: "#7A5C09"
  },
  danger: {
    100: "#FFE7D5",
    200: "#FFCAAB",
    300: "#FFA581",
    400: "#FF8261",
    500: "#FF492D",
    600: "#DB2B20",
    700: "#B7161A",
    800: "#930E1C",
    900: "#7A081D"
  }
};
var spacing = {
  __description: "Spacing",
  0: "0",
  2: "0.125rem",
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem"
};
var shadows = {
  0: "none",
  1: "0 0.0625rem 0.1875rem rgba(0,0,0,0.12), 0 0.0625rem 0.125rem rgba(0,0,0,0.24)",
  2: "0 0.125rem 0.25rem rgba(0,0,0,0.14), 0 0.125rem 0.1875rem rgba(0,0,0,0.22)",
  3: "0 0.1875rem 0.3125rem rgba(0,0,0,0.16), 0 0.1875rem 0.25rem rgba(0,0,0,0.20)",
  4: "0 0.25rem 0.375rem rgba(0,0,0,0.18), 0 0.25rem 0.3125rem rgba(0,0,0,0.18)",
  5: "0 0.3125rem 0.4375rem rgba(0,0,0,0.20), 0 0.3125rem 0.375rem rgba(0,0,0,0.16)",
  6: "0 0.375rem 0.5rem rgba(0,0,0,0.22), 0 0.375rem 0.4375rem rgba(0,0,0,0.14)",
  7: "0 0.4375rem 0.5625rem rgba(0,0,0,0.24), 0 0.4375rem 0.5rem rgba(0,0,0,0.12)",
  8: "0 0.5rem 0.625rem rgba(0,0,0,0.26), 0 0.5rem 0.5625rem rgba(0,0,0,0.10)"
};
var theme = {
  theme: "dark",
  screens: {
    lg: "768px"
  },
  spacing: spacing,
  color: {
    __description: "Color palette",
    primary: {
      __: "#111111",
      main: "#111111",
      hover: "#181818",
      active: "#080808",
      disabled: "#525252",
      bgLight: "#EEEEEE"
    },
    accent: {
      __: colors.accent[800],
      main: colors.accent[800],
      hover: colors.accent[700],
      active: colors.accent[900],
      disabled: colors.accent[500],
      bgLight: colors.accent[200]
    },
    success: {
      __: colors.success[800],
      main: colors.success[800],
      hover: colors.success[700],
      active: colors.success[900],
      disabled: colors.success[500],
      bgLight: colors.success[200]
    },
    warning: {
      __: colors.warning[700],
      main: colors.warning[700],
      hover: colors.warning[600],
      active: colors.warning[800],
      disabled: colors.warning[400],
      bgLight: colors.warning[200]
    },
    danger: {
      __: colors.danger[700],
      main: colors.danger[700],
      hover: colors.danger[600],
      active: colors.danger[800],
      disabled: colors.danger[400],
      bgLight: colors.danger[200]
    }
  },
  borderRadius: {
    __description: "Shapes",
    none: "0",
    sm: "0.125rem",
    md: "0.375rem",
    lg: "0.5rem",
    full: "100rem"
  },
  typography: {
    __description: "Typography & Fonts",
    fontFamily: "",
    fontFamilyCode: "",
    fontFamilyTagline: "",
    fontFamilySystem: "",
    fontWeightSemiBold: 600,
    fontWeightExtraBold: 800,
    h1: {
      fontFamily: "",
      fontSize: "clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)",
      fontWeight: 800,
      lineHeight: 1.1142857142857143
    },
    h2: {
      fontFamily: "",
      fontSize: "clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)",
      fontWeight: 800,
      lineHeight: 1.2222222222222223,
      color: "#132F4C"
    },
    h3: {
      fontFamily: "",
      fontSize: "2.25rem",
      lineHeight: 1.2222222222222223,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h4: {
      fontFamily: "",
      fontSize: "1.75rem",
      lineHeight: 1.5,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h5: {
      fontFamily: "",
      fontSize: "1.5rem",
      lineHeight: 1.5,
      letterSpacing: 0.1,
      color: "#007FFF",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h6: {
      fontSize: "1.25rem",
      lineHeight: 1.5,
      fontFamily: "",
      fontWeight: 500,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    button: {
      textTransform: "initial",
      fontWeight: 700,
      letterSpacing: 0,
      fontFamily: "",
      fontSize: "0.875rem",
      lineHeight: 1.75,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    subtitle1: {
      fontSize: "1.125rem",
      lineHeight: 1.3333333333333333,
      letterSpacing: 0,
      fontWeight: 500,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    caption: {
      display: "inline-block",
      fontSize: "0.75rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontWeight: 700,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    allVariants: {
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    subtitle2: {
      fontFamily: "",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    overline: {
      fontFamily: "",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      textTransform: "uppercase",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    }
  },
  shadows: _objectSpread(_objectSpread({}, shadows), {}, {
    appBar: shadows["3"],
    fab: shadows["5"]
  }),
  transition: {
    __description: "Animations timings",
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    duration: {
      s: 100,
      m: 250,
      l: 500
    }
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  }
};
module.exports = {
  theme: theme,
  colors: colors
};

/***/ }),

/***/ 521023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


"use client";

var _interopRequireDefault = __webpack_require__(564836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(864938));
var _jsxRuntime = __webpack_require__(785893);
var _default = exports["default"] = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');

/***/ }),

/***/ 408857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


"use client";

var _interopRequireDefault = __webpack_require__(564836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(864938));
var _jsxRuntime = __webpack_require__(785893);
var _default = exports["default"] = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonChecked');

/***/ }),

/***/ 459462:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


"use client";

var _interopRequireDefault = __webpack_require__(564836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(864938));
var _jsxRuntime = __webpack_require__(785893);
var _default = exports["default"] = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');

/***/ }),

/***/ 916976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wx": function() { return /* binding */ Option; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "f6": function() { return /* binding */ PrimaryBtn; },
/* harmony export */   "qL": function() { return /* binding */ Para; },
/* harmony export */   "ry": function() { return /* binding */ SecondaryBtn; },
/* harmony export */   "si": function() { return /* binding */ ActionTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _mui_icons_material_RadioButtonUnchecked__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(459462);
/* harmony import */ var _mui_icons_material_RadioButtonChecked__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(408857);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(326706);




var Heading = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
        className: "tw-text-7 tw-m-0 tw-text-xl",
        children: props.children
    });
};
var Para = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "tw-m-0 ".concat((props === null || props === void 0 ? void 0 : props.large) ? "tw-text-base/5" : "tw-text-sm", " tw-font-normal tw-text-[#4E4E4E] ").concat(props.className || ""),
        children: props.children
    });
};
var PrimaryBtn = function(param) {
    var text = param.text, onClick = param.onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store.theme;
    });
    var primaryColor = theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color;
    var rounded = theme === null || theme === void 0 ? void 0 : theme.roundness;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "tw-rounded-lg tw-border-0 tw-bg-[#2B74D8] tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white ".concat(disabled ? "tw-opacity-30" : "", " ").concat(className),
        onClick: onClick,
        disabled: disabled,
        style: {
            backgroundColor: primaryColor,
            borderRadius: rounded
        },
        children: text
    });
};
var SecondaryBtn = function(param) {
    var text = param.text, onClick = param.onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-[#222222] ".concat(disabled ? "tw-opacity-35" : "", " ").concat(className),
        onClick: onClick,
        disabled: disabled,
        children: text
    });
};
var Option = function(param) {
    var reason = param.reason, isSelected = param.isSelected, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-2.5",
        onClick: onSelect,
        children: [
            isSelected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_RadioButtonChecked__WEBPACK_IMPORTED_MODULE_2__["default"], {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_RadioButtonUnchecked__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Para, {
                large: true,
                children: reason
            })
        ]
    });
};
var ActionTab = function(param) {
    var Icon = param.Icon, text = param.text, handler = param.handler;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: "tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-none tw-border-0 tw-border-b tw-border-solid tw-border-[#E0E0E0] tw-bg-transparent tw-px-4 tw-py-5 tw-text-black last:tw-border-0",
        onClick: handler,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {}),
            text
        ]
    });
};


/***/ }),

/***/ 96699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_MyAccount; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(704956);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(521023);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/containers/MyAccount/components/Header/index.js



var Header = function() {
    var onGoBackClick = function() {
        router_default().back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "tw-w-100 tw-z-10 tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-text-[1rem] tw-font-bold tw-leading-5 tw-shadow-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack["default"], {
                onClick: onGoBackClick
            }),
            "My Account"
        ]
    });
};
/* harmony default export */ var components_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/containers/MyAccount/components/AllModalContainer/index.js






var DeleteConfirmationModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3803).then(__webpack_require__.bind(__webpack_require__, 223803));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(223803)
            ];
        }
    }
});
var FeedbackModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4247).then(__webpack_require__.bind(__webpack_require__, 954247));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(954247)
            ];
        }
    }
});
var VerifyOtpModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8637), __webpack_require__.e(4666)]).then(__webpack_require__.bind(__webpack_require__, 428637));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(428637)
            ];
        }
    }
});
var AllModalContainer = function(param) {
    var modalState = param.modalState, setModalState = param.setModalState, onConfirmAccountDelete = param.onConfirmAccountDelete, onSubmitFeedback = param.onSubmitFeedback, onOtpVerificationSuccess = param.onOtpVerificationSuccess;
    switch(true){
        case modalState.showConfirmationModal:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteConfirmationModal, {
                onClose: function() {
                    return setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
                        showConfirmationModal: false
                    }));
                },
                onConfirmAccountDelete: onConfirmAccountDelete
            });
        case modalState.showFeedbackModal:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackModal, {
                onClose: function() {
                    return setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
                        showFeedbackModal: false
                    }));
                },
                onSubmitFeedback: onSubmitFeedback
            });
        case modalState.showVerifyOtpModal:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyOtpModal, {
                onClose: function() {
                    return setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
                        showVerifyOtpModal: false
                    }));
                },
                onOtpVerificationSuccess: onOtpVerificationSuccess,
                isCustomerLoggedIn: true
            });
        case modalState.showLogoutConfirmationModal:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: function() {
                    return setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
                        showLogoutConfirmationModal: false
                    }));
                },
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: true
            });
        default:
            return null;
    }
};
/* harmony default export */ var components_AllModalContainer = (AllModalContainer);

;// CONCATENATED MODULE: ./src/containers/MyAccount/svgExports/index.js

var OrderIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.58331 19.1667C3.07915 19.1667 2.64755 18.9872 2.28852 18.6281C1.92949 18.2691 1.74998 17.8375 1.74998 17.3333V6.99793C1.47498 6.82987 1.25345 6.61216 1.0854 6.3448C0.917341 6.07744 0.833313 5.76807 0.833313 5.41668V2.66668C0.833313 2.16251 1.01283 1.73091 1.37185 1.37189C1.73088 1.01286 2.16248 0.833344 2.66665 0.833344H17.3333C17.8375 0.833344 18.2691 1.01286 18.6281 1.37189C18.9871 1.73091 19.1666 2.16251 19.1666 2.66668V5.41668C19.1666 5.76807 19.0826 6.07744 18.9146 6.3448C18.7465 6.61216 18.525 6.82987 18.25 6.99793V17.3333C18.25 17.8375 18.0705 18.2691 17.7114 18.6281C17.3524 18.9872 16.9208 19.1667 16.4166 19.1667H3.58331ZM3.58331 7.25001V17.3333H16.4166V7.25001H3.58331ZM2.66665 5.41668H17.3333V2.66668H2.66665V5.41668ZM7.24998 11.8333H12.75V10H7.24998V11.8333Z",
            fill: "black"
        })
    });
};
var DeleteIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.41669 17.25C2.91252 17.25 2.48092 17.0705 2.1219 16.7115C1.76287 16.3524 1.58335 15.9208 1.58335 15.4167V3.5H0.666687V1.66667H5.25002V0.75H10.75V1.66667H15.3334V3.5H14.4167V15.4167C14.4167 15.9208 14.2372 16.3524 13.8781 16.7115C13.5191 17.0705 13.0875 17.25 12.5834 17.25H3.41669ZM12.5834 3.5H3.41669V15.4167H12.5834V3.5ZM5.25002 13.5833H7.08335V5.33333H5.25002V13.5833ZM8.91669 13.5833H10.75V5.33333H8.91669V13.5833Z",
            fill: "black"
        })
    });
};
var ExitIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.58333 17.25C2.07917 17.25 1.64757 17.0705 1.28854 16.7115C0.929514 16.3524 0.75 15.9208 0.75 15.4167V2.58333C0.75 2.07917 0.929514 1.64757 1.28854 1.28854C1.64757 0.929514 2.07917 0.75 2.58333 0.75H9V2.58333H2.58333V15.4167H9V17.25H2.58333ZM12.6667 13.5833L11.4062 12.2542L13.7438 9.91667H6.25V8.08333H13.7438L11.4062 5.74583L12.6667 4.41667L17.25 9L12.6667 13.5833Z",
            fill: "black"
        })
    });
};

// EXTERNAL MODULE: ./src/utils/handleRouteChangesOnClick.js
var handleRouteChangesOnClick = __webpack_require__(27909);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/containers/MyAccount/components/Common/index.js
var Common = __webpack_require__(916976);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(656173);
;// CONCATENATED MODULE: ./src/containers/MyAccount/components/UserOptions/index.js














var UserOptions = function() {
    var onOrdersClick = /* --- page cta actions --- */ function onOrdersClick() {
        (0,handleRouteChangesOnClick/* handleRouteChangesOnClick */.Z)(routes.PATH.ORDERS);
    };
    var onDeleteAccountClick = function onDeleteAccountClick() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            showConfirmationModal: true
        }));
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            showLogoutConfirmationModal: !modalState.showLogoutConfirmationModal
        }));
    };
    var onConfirmAccountDelete = /* --- modal cta actions --- */ function onConfirmAccountDelete() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            showConfirmationModal: false,
            showFeedbackModal: true
        }));
    };
    var onSubmitFeedback = function onSubmitFeedback(text) {
        setFeedback(text);
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            showFeedbackModal: false,
            showVerifyOtpModal: true
        }));
    };
    var onDeletetionSuccess = function onDeletetionSuccess() {
        (0,Toast/* toastNotifySuccess */.jh)("Account deleted successfully!");
        (0,excuteLogout/* executeLogout */.q)();
    };
    var onOtpVerificationSuccess = function onOtpVerificationSuccess() {
        var payload = {
            store_id: storeId,
            user_id: userId,
            feedback: feedback
        };
        dispatch((0,user/* deleteUserAccount */.xU)(payload, onDeletetionSuccess));
    };
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            storeId: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_id,
            userId: ((ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.user_id) || ""
        };
    }), storeId = ref.storeId, userId = ref.userId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)({
        showLogoutConfirmationModal: false,
        showConfirmationModal: false,
        showFeedbackModal: false,
        showVerifyOtpModal: false
    }), modalState = ref1[0], setModalState = ref1[1];
    var ref2 = (0,react.useState)(""), feedback = ref2[0], setFeedback = ref2[1];
    var OPTIONS = [
        {
            Icon: OrderIcon,
            text: "Orders",
            handler: onOrdersClick
        },
        {
            Icon: DeleteIcon,
            text: "Delete account",
            handler: onDeleteAccountClick
        },
        {
            Icon: ExitIcon,
            text: "Log out",
            handler: toggleLogoutModal
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-flex-col",
                children: OPTIONS.map(function(option, index) {
                    return /*#__PURE__*/ (0,react.createElement)(Common/* ActionTab */.si, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
                        key: index
                    }));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AllModalContainer, {
                modalState: modalState,
                setModalState: setModalState,
                onConfirmAccountDelete: onConfirmAccountDelete,
                onSubmitFeedback: onSubmitFeedback,
                onOtpVerificationSuccess: onOtpVerificationSuccess
            })
        ]
    });
};
/* harmony default export */ var components_UserOptions = (UserOptions);

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/containers/MyAccount/index.tsx








var MyAccount = function() {
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) && !(0,getNavList/* showMyAccount */.p6)()) {
            (0,handleRouteChangesOnClick/* handleRouteChangesOnClick */.Z)(routes.PATH.PRODUCT);
        }
    }, [
        storeInfo.store_id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-h-screen tw-w-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserOptions, {})
        ]
    });
};
/* harmony default export */ var containers_MyAccount = (MyAccount);


/***/ }),

/***/ 704956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ showMyAccount; }
/* harmony export */ });
/* unused harmony export isUserLoggedIn */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(629815);
/* harmony import */ var _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(313508);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167261);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(506337);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(913886);






var isUserLoggedIn = function() {
    var ref;
    return !!((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.isLogin);
};
var showMyAccount = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__/* .IS_MOBILE */ .q$ && _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_WEBVIEW */ .x5 && isUserLoggedIn();
};
var myAccountNavData = {
    page_name: "My Account",
    slug_url: _routes__WEBPACK_IMPORTED_MODULE_3__.PATH.MY_ACCOUNT,
    page_type: "my-account"
};
var getNavList = function(navigationItems) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: showCategories ? "Categories" : "More",
        slug_url: showCategories ? "more" : "subNavList"
    };
    var showMyAccountSection = showMyAccount();
    if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > 0) {
        var tempNavList = [];
        if (showCategories) {
            tempNavList = navigationItems.filter(function(nav) {
                return nav.page_type !== "shop";
            });
        } else {
            tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(navigationItems);
        }
        if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > visibleItemsLength) {
            var extractedNavList = tempNavList.splice(visibleItemsLength, tempNavList.length);
            subNavObj.subNavs = extractedNavList;
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
            }
            var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tempNavList).concat([
                subNavObj
            ]);
            return newNavList;
        } else {
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
                tempNavList.push(subNavObj);
            }
            return tempNavList;
        }
    }
    return [];
};
/* harmony default export */ __webpack_exports__["ZP"] = (getNavList);


/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ })

}]);